export const setIntervalWithTimeLimit = (
  callback: (clear: () => void) => any,
  maxTime: number,
  interval: number,
) => {
  const maxEndTime = new Date().getTime() + maxTime;
  const intervalId = setInterval(() => {
    callback(() => {
      clearInterval(intervalId);
    });
    if (maxEndTime <= new Date().getTime()) {
      clearInterval(intervalId);
    }
  }, interval);
};

/**
 * Used to address problem of promises returning after a component unmounts
 * see: https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
 * credit: https://github.com/facebook/react/issues/5465#issuecomment-157888325
 *
 * @param promise promise to make cancelable
 */
export const makeCancelable = (promise: Promise<any>) => {
  let hasCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise
      .then(val => (hasCanceled ? reject({ isCanceled: true }) : resolve(val)))
      .catch(error => (hasCanceled ? reject({ isCanceled: true }) : reject(error)));
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled = true;
    },
  };
};

export type CancelablePromise = {
  promise: Promise<any>;
  cancel: () => void;
};
